import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { DirectivesModule } from '../../directives/directive.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TrackingAnalysis } from './tracking-analysis.component';
import { HuddyHeatMapModule } from '../../components/huddy-heat-map/heat-map.module';
import { MatInputModule } from '@angular/material/input';
import { MatButton, MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    TrackingAnalysis
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    ReactiveFormsModule,
    NgxChartsModule,
    HuddyHeatMapModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule
  ],
  exports: [
    TrackingAnalysis
  ]
})
export class TrackingAnalysisModule {}
